import clsx from "clsx";

/**
 * Props interface for the Container component.
 */
interface ContainerProps {
  /** Child components to render inside the container */
  children: React.ReactNode;
  /** Optional additional CSS classes */
  className?: string;
}

/**
 * A reusable container component that provides consistent styling for form elements.
 *
 * Features:
 * - AuthLayout container styling (border-4 border-black bg-gray-100 rounded-xl)
 * - Consistent padding and spacing
 * - Flexible content area for any form elements
 * - Reusable across different form types
 *
 * @example
 * ```tsx
 * <Container>
 *   <InputField {...props} />
 * </Container>
 * ```
 */
export default function Container({ children, className }: ContainerProps) {
  return <div className={clsx("border-4 border-black bg-gray-100 rounded-xl p-4", className)}>{children}</div>;
}
